function view (path) {
  return () => import(/* webpackChunkName: 'admin' */ '@/views/admin/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

// Admin routes
const RAdmin = [
  {
    path: '/admin/users',
    component: view('Users'),
    name: 'admin.users',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/appointments',
    component: view('Appointments'),
    name: 'admin.appointments',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Appointments',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/lost-and-found',
    component: view('LostAndFound'),
    name: 'admin.lost-and-found',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Lost & Found',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/students',
    component: view('Students'),
    name: 'admin.students',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Students',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/student-residences',
    component: view('StudentResidences'),
    name: 'admin.student-residences',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Student Residences',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/violations',
    component: view('Violations'),
    name: 'admin.violations',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Violations',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/violation-types',
    component: view('ViolationTypes'),
    name: 'admin.violation-types',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Violation Types',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/appointment-slots',
    component: view('AppointmentSlots'),
    name: 'admin.appointment-slots',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Appointment Slots',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/appointment-concern-types',
    component: view('AppointmentConcernTypes'),
    name: 'admin.appointment-concern-types',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Concern Types',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/appointment-notification-settings',
    component: view('AppointmentNotificationSettings'),
    name: 'admin.appointment-notification-settings',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Appointment Notification Settings',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/lf-item-categories',
    component: view('LfItemCategories'),
    name: 'admin.lf-item-categories',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'L&F Categories',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/lf-item-claims',
    component: view('LfItemClaims'),
    name: 'admin.lf-item-claims',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Item Claims',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/resource-categories',
    component: view('ResourceCategories'),
    name: 'admin.resource-categories',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Resource Categories',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/resources',
    component: view('Resources'),
    name: 'admin.resources',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Resources',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/complaints',
    component: view('Complaints'),
    name: 'admin.complaints',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Complaints',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/feedback',
    component: view('Feedback'),
    name: 'admin.feedback',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Feedback',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/announcements',
    component: view('Announcements'),
    name: 'admin.announcements',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Announcements',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/events',
    component: view('Events'),
    name: 'admin.events',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Events',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/counseling-chat',
    component: view('CounselingChat'),
    name: 'admin.counseling-chat',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Counseling Chat',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/activity-logs',
    component: view('ActivityLogs'),
    name: 'admin.activity-logs',
    meta: {
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Activity Logs',
          active: true
        }
      ]
    }
  }
]

export default RAdmin
